export default __webpack_public_path__ + "static/media/voice-image.66abcd5a.svg";